<template>
    <div v-if="loaded">
        <base-filter v-on:filter-set="onFilterSet" v-on:filter-reset="onFilterReset"></base-filter>
        <div class="table-responsive">
            <vuetable ref="vuetable"
                      :api-url="apiurl + listUrl"
                      :fields="fields"
                      :css="css.table"
                      :per-page="20"
                      pagination-path=""
                      track-by="id"
                      data-path="mydata"
                      :append-params="moreParams"
                      :no-data-template="$t('Nincs elérhető adat.')"
                      :http-options="{ headers: {Authorization: 'Bearer ' + token} }"
                      @vuetable:pagination-data="onPaginationData"
                      @vuetable:loaded="onLoaded"
            >
                <template slot="checkboxSupplier" slot-scope="props">
                    <div class="m-checkbox-list">
                        <label class="m-checkbox">
                            <input type="checkbox" v-on:change="setChecked(props.rowData)">
                            <span></span>
                        </label>
                    </div>
                </template>
                <template slot="actions" slot-scope="props">
                    <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {{$t('Actions')}}
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item" @click="editAction(props.rowData, props.rowIndex)">
                                <i class="fa fa-edit"></i> {{$t('Edit')}}
                            </a>
                            <a class="dropdown-item" @click="deleteAction(props.rowData, props.rowIndex)">
                                <i class="fa fa-trash-alt"></i> {{$t('Delete')}}
                            </a>
                        </div>
                    </div>
                </template>
            </vuetable>
        </div>
        <div class="m-portlet__foot">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <vuetable-pagination-info v-if="language == 'en'" ref="paginationInfo"
                                              info-template="Showing record {from} to {to} of {total} records"
                                              no-data-template="No relevant data">

                    </vuetable-pagination-info>
                    <vuetable-pagination-info v-if="language == 'hu'" ref="paginationInfo"
                                              info-template="Találatok mutatása {from}-tól {to}-ig a {total}-ból"
                                              no-data-template="Nincs találat">

                    </vuetable-pagination-info>
                </div>
                <div class="col-lg-6 ">
                    <vuetable-pagination-bootstrap ref="pagination" class="pull-right"
                                                   @vuetable-pagination:change-page="onChangePage"></vuetable-pagination-bootstrap>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePaginationBootstrap from './VuetablePaginationBootstrap'
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import BaseFilter from './BaseFilter'
import RiseLoader from 'vue-spinner/src/RiseLoader'

export default {
  name: 'BaseDatatable',
  props: {
    editString: {
      type: String,
      default: ''
    },
    disableDelete: {
      type: Boolean,
      default: false
    },
    disableEdit: {
      type: Boolean,
      default: false
    },
    selectedIds: {
      type: Array
    },
    apiurl: {
      type: String,
      required: true
    },
    module: {
      type: String,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    sortOrder: {
      type: Array,
      default () {
        return []
      }
    },
    loaded: {
      default: 1
    },
    customListUrl: {
      default: 0
    },
    appendParams: {
      type: Object,
      default () {
        return {}
      }
    },
    detailRowComponent: {
      type: String
    }
  },
  data () {
    return {
      loading: true,
      token: localStorage.getItem('token'),
      moreParams: {},
      filters: {},
      baseUrl: process.env.API_URL,
      css: {
        table: {
          tableClass: 'table table-bordered table-striped table-hover',
          ascendingIcon: 'fa fa-sort-asc',
          descendingIcon: 'fa fa-sort-desc'
        }
      }
    }
  },
  components: {
    RiseLoader,
    BaseFilter,
    VuetablePaginationBootstrap,
    Vuetable,
    VuetablePaginationInfo
  },
  computed: {
    language: {
      get: function () {
        return this.$store.state.loading.language
      },
      set: function (val) {
        return this.$store.state.loading.language
      }
    },
    listUrl () {
      if (this.customListUrl !== 0) {
        return this.customListUrl
      }

      return '/index'
    }
  },
  methods: {
    setChecked (data) {
      let haveIn = false
      for (let it in this.selectedIds) {
        if (this.selectedIds[it].id === data.id) {
          haveIn = it
        }
      }

      if (!haveIn) {
        this.selectedIds.push(data)
      } else {
        this.selectedIds.splice(haveIn, 1)
      }
    },
    onLoaded () {
      this.$store.commit('loading/change', false)
      this.loading = false
    },
    editAction (data, index, props) {
      this.$router.push(`/admin/${this.module}/edit/${data.id}`)
    },
    deleteAction (data, index) {
      let self = this
      window.swal({
        title: this.$t('Are you sure?'),
        text: this.$t('You won\'t be able to revert this!'),
        type: 'warning',
        showCancelButton: !0,
        confirmButtonText: this.$t('Yes, delete it!'),
        cancelButtonText: this.$t('No, cancel!'),
        reverseButtons: !0
      }).then(function (e) {
        if (e.value) {
          self.$http.delete(self.apiurl + `/delete/${data.id}`, {
            'headers': {
              'Authorization': 'Bearer ' + localStorage.getItem('token'),
              'language': self.$store.state.loading.language
            }
          }).then(res => {
            if (res.data.data.message === 'OK') {
              self.$nextTick(() => self.$refs.vuetable.refresh())

              window.swal(this.$t('Deleted!'), this.$t('Row has been deleted.'), 'success')
            }
          }).catch(res => {

          })
        }
      })
    },
    onFilterSet (val) {
      this.moreParams = Object.assign({}, {
        'search-fillable': val
      })

      this.$emit('filters', this.moreParams)
      this.$nextTick(() => this.$refs.vuetable.refresh())
    },
    onFilterReset () {
      this.moreParams = Object.assign({}, {})

      this.$emit('filters', this.moreParams)

      this.$nextTick(() => this.$refs.vuetable.refresh())
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    transform: function (data) {
      let transformed = {}

      transformed.pagination = {
        total: data.meta.total,
        per_page: data.meta.per_page,
        current_page: data.meta.current_page,
        last_page: data.meta.last_page,
        next_page_url: (data.links.next !== null) ? data.links.next : data.links.last,
        prev_page_url: (data.links.prev !== null) ? data.links.prev : data.links.first,
        from: data.meta.from,
        to: data.meta.to
      }

      transformed.total = data.meta.total
      transformed.per_page = data.meta.per_page
      transformed.current_page = data.meta.current_page
      transformed.last_page = data.meta.last_page
      transformed.next_page_url = data.links.next
      transformed.prev_page_url = data.links.prev
      transformed.from = data.meta.from
      transformed.to = data.meta.to

      transformed.mydata = []

      for (let i = 0; i < data.data.length; i++) {
        transformed.mydata.push(data.data[i])
      }

      return transformed
    },
    hasError (val) {
      for (let er in this.errors) {
        if (er === val) {
          return true
        }
      }

      return false
    },
    filter: function (name) {
      for (let er in this.errors) {
        if (er === name) {
          this.hasDanger = true
          return this.errors[er]
        }
      }

      this.hasDanger = false
      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/BaseDatatable.vue